import axios from "axios";
import { proxyUrl } from "../config";
import { setupInterceptorsTo } from "./Interceptors";
import { SignatureContractElements } from "./ElementsService";
import { UserIdentityType } from "./UserIdentitiesService";
setupInterceptorsTo(axios);

export interface BrowserInfo {
  browserName: string;
  browserVersion: string;
  platform: string;
  language: string;
  userAgent: string;
}

export interface TicketSupportError {
  status: boolean;
  message: string;
}

export interface TicketSupportData {
  message: string;
  browserInfo: BrowserInfo;
  screenshot: string | null;
  screenName: string;
  path: string;
  timestamp: string;
  userIdentity?: string;
  formVal?: string;
  financialFormVal?: string;
  error?: TicketSupportError;
  title?: string;
  userId?: number | string;
  savingPlanId?: number | string;
  signaturesContractElements?: SignatureContractElements[];
  ticketError: TicketSupportError;
  userIdentities?: UserIdentityType[];
}

export interface TicketSupportResponse {
  Status: number;
  Message: string;
  Id?: string;
}

class TicketSupport {
  public createNewSupportTicket = async (
    ticket: TicketSupportData
  ): Promise<TicketSupportResponse> => {
    const url: string = `${proxyUrl}/ticket-support/new`;
    const req = await axios.post<TicketSupportResponse>(url, ticket);
    return req.data;
  };
}

const TicketSupportService = new TicketSupport();
export default TicketSupportService;
